import React from 'react';
import { Modal } from 'react-bootstrap';
// import { getTree } from './action/treeAction';
import ModalBody from './modalBody';

/**Handles the modal functionality for the nodes */
class ParentModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            edit: false,
            title: "hub"
        }
    }


    hide = () => {
        this.props.hide();
    }

    componentWillMount() {
        if (this.props.parent.edit === true) {
            this.setState({ edit: true })
        }
        this.setState({
            readOnly: this.props.readOnly,
            sourcesAllowed: this.props.sourcesAllowed
        });
    }
    componentWillReceiveProps(nextProps) {
        if (!this.state.edit && nextProps.parent.edit) {
            this.setState({ edit: true });
        } else if (this.state.edit && !nextProps.parent.edit) {
            this.setState({ edit: false });
        }
    }
    componentWillUnmount() {
        this.setState({ edit: false })
    }
    titleSetter = (title) => {
        this.setState({ title: title });
    }
    exitModal = () => {
        this.setState({ key: 1 });
        this.setState({ colour: null });
    }

    render() {
        return (
            <div>
                <Modal show={this.props.show}
                    onHide={this.hide}
                    onEnter={this.onEnter}
                    onExit={this.exit}
                    size="large"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{this.state.edit ? "Edit" : "Create"} a {this.state.title}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <ModalBody readOnly={this.state.readOnly} colour={this.props.parent.colour} parent={this.props.parent}
                            edit={this.state.edit} hide={this.hide} titleChanger={this.titleSetter} sourcesAllowed={this.state.sourcesAllowed}/>
                        {/* <p>{props.parent}</p> */}
                    </Modal.Body>
                    <Modal.Footer>
                    </Modal.Footer>
                </Modal>
            </div>
        )
    }
}


export default ParentModal;



// WEBPACK FOOTER //
// ./src/components/tree/node/modal.js